import { ArrowLeftIcon } from '../../../../../../assets/svg/arrow-left';
import { ArrowRightIcon } from '../../../../../../assets/svg/arrow-right';
import { Card } from '../../../../../../components/card/card';
import { IconButton } from '../../../../../../components/icon-button/icon-button';
import { Label } from '../../../../../../components/label/label';
import { RadioButton } from '../../../../../../components/radio-button/radio-button';
import { DatePickerCalendar } from '../../../../../../features/date-time/date-picker/date-picker-calendar/date-picker-calendar';
import { Tooltip } from '../../../../../../features/tooltip/tooltip';
import { ShiftsDatesInfo } from './shifts-dates-info/shifts-dates-info';
import s from './shifts-dates.module.css';
import { useShiftsDates } from './use-shifts-dates';

export const ShiftsDates = () => {
  const {
    t,
    handleChangePeriod,
    period,
    handleNext,
    handlePrev,
    displayRange,
    handleSelectDate,
    selectedDate,
  } = useShiftsDates();

  return (
    <ul className={s.feature}>
      <Card className={s.range}>
        <IconButton variant="ghost" onClick={handlePrev}>
          <ArrowLeftIcon />
        </IconButton>
        <Tooltip trigger={displayRange} triggerWrapperClassName={s.trigger}>
          <DatePickerCalendar
            type={period}
            handleSelectDate={handleSelectDate}
            selectedDate={selectedDate}
            disabledOutOfMonth={false}
          />
        </Tooltip>
        <IconButton variant="ghost" onClick={handleNext}>
          <ArrowRightIcon />
        </IconButton>
      </Card>
      <Card className={s.period}>
        <Label>{t('Вид')}</Label>
        <ul className={s.periods}>
          <RadioButton
            label={t('День')}
            size="lg"
            checked={period === 'day'}
            onClick={() => handleChangePeriod('day')}
          />
          <RadioButton
            label={t('Неделя')}
            size="lg"
            checked={period === 'week'}
            onClick={() => handleChangePeriod('week')}
          />
          <RadioButton
            label={t('Месяц')}
            size="lg"
            checked={period === 'month'}
            onClick={() => handleChangePeriod('month')}
          />
        </ul>
      </Card>
      <ShiftsDatesInfo />
    </ul>
  );
};
